function ReCertificationTable({
  GetSpecificUser,
  GetClientFormIMS_Data,
  GetClientFormFSMS_Data,
  parsedFormData,
  SaleName,
}) {
  const shortenText = (text, wordLimit) => {
    const words = text.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + " ...";
    }
    return text;
  };
  const HACCP =
    GetSpecificUser.standardsSchemeType === "FSMS"
      ? `<tr>
        <td>No. of HACCP study :</td>
        <td>${GetClientFormFSMS_Data.NoOfHACCP_study}</td>
      </tr>`
      : "";
  const SchemeType =
    GetSpecificUser.standardsSchemeType === "IMS"
      ? GetClientFormIMS_Data
      : GetClientFormFSMS_Data;
  const Scopeaudit =
    GetSpecificUser.standardsSchemeType === "FSMS"
      ? ` <tr style="height:300px">
              <td style="vertical-align: top;">Scope of certification:</td>
              <td style="vertical-align: top;"> ${SchemeType.scopeOfCertification}</td>
            </tr>`
      : ` <tr style="height:330px">
              <td style="vertical-align: top;">Scope of certification:</td>
              <td style="vertical-align: top;"> ${SchemeType.scopeOfCertification}</td>
            </tr>`;
  const AuditVal =
    GetSpecificUser.standardsSchemeType === "IMS"
      ? "CAUSSA-CB-F-18"
      : "CAUSSA-CB-F-42";
  const dateString = `${SchemeType.proposalDate}`;
  const dateOnly = dateString.slice(0, 10);
  const dateString1 = `${SchemeType.expectedDateOfAuditPlanned}`;
  const dateOnly1 = dateString1.slice(0, 10);

  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();
  const formattedDate = `${String(day).padStart(2, "0")}-${String(
    month
  ).padStart(2, "0")}-${year}`;
  const TableHeader = `
  <table>
        <tr>
          <td rowspan="2">
            <img
              width="51"
              height="50"
              src="data:image/jpg;base64,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"
            />
          </td>
          <td rowspan="2" class="text-center fw-bold">
            PROPOSAL & AGREEMENT FOR THIRD PARTY AUDIT -  ${GetSpecificUser.standardsSchemeType}
          </td>
          <td>Doc No.</td>
          <td>${AuditVal}</td>
        </tr>
        <tr>
          <td>Revision No. & Date</td>
          <td>Rev. No. 0 / OCT/2023</td>
        </tr>
      </table>`;
  const BreakTable =
    GetSpecificUser.standardsSchemeType === "IMS"
      ? `
        <div style="height:300px"></div>
      `
      : `
        <div style="height:260px"></div>
      `;
  return `
<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Proposal & Agreement for Third Party Audit -  ${GetSpecificUser.standardsSchemeType
    }</title>
    <style>
    @media print {
  body {
    font-size: 10px; /* Adjust the font size for print */
  }
}
  tr,th,td,p,li{
  font-size:10px!important}
      body {
      width:595;
      font-size:12px!important;
        font-family: Arial, sans-serif;
        margin: 20px;
        background: black;
      }
      .main {
        width: 100%;
        background: white;
        padding: 10px;
        font-size: 13px;
      }
      /* common */
      h5{
      font-size:14px;}
      table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 20px;
      }
      table,
      th,
      td {
        border: 1px solid #e4e4e4;
      }
      th,
      td {
        padding: 8px;
        text-align: left;
      }
      .fw-bold {
        font-weight: bold;
      }
      .text-center {
        text-align: center;
      }
      .xs {
        font-size: 13px;
      }
      .mb-0 {
        margin-bottom: 0px !important;
      }
      .m-0 {
        margin: 0px !important;
      }
      .text-danger {
        color: red;
      }
      .list-type-none li {
        list-style-type: none !important;
      }
      .border-box {
        width: 10px;
        height: 10px;
        border: 1px solid black;
        display: inline-block;
      }
      .border-top-none {
        border-top: 1px solid white !important;
      }
      .border-bottom-none {
        border-bottom: 1px solid white !important;
      }
      .border-left-none {
        border-left: 1px solid white !important;
      }
      .border-right-none {
        border-right: 1px solid white !important;
      }
      .no-break {
        page-break-inside: avoid;
      }
      /* common */

      /* Account */
      .Account-table td {
        width: 25%;
        font-size: 12px;
      }
      /* Account */

      /* Proposal */
      .Proposal-table td {
        font-size: 12px;
      }

      .Proposal-table tr td:nth-child(1) {
         width: 30%;
      }

      .Proposal-table tr td:nth-child(2) {
         width: 70%;
      }
      /* Proposal */
      #Main-table th,
      #Main-table td {
        font-size: 12px;
        text-align: center;
      }
      .bg-Green {
        background-color: #89b72b !important;
      }
      ul{
        padding-left:20px;!important}
      ul> li > *:first-child:before{
      content: " ";
                color: black;
                font-family: Symbol, serif;
                font-style: normal;
                font-weight: normal;
                text-decoration: none;
                font-size: 11pt;
      }
                li {
                display: block;
            }
      ul li {
        padding: 7px 0px;
      }
        .border-none{
        border:none!important}
    </style>
  </head>
  <body>
    <div class="main">
      ${TableHeader}
      <h5 style="font-size:12px"><span class="fw-bold">Proposal for: </span>${GetSpecificUser.companyName
    }</h5>
      <div style="margin:10px 0px">
      <h5 style="font-size:12px"><span class="fw-bold">Prepared by:</span> ${SaleName}</h5>
      <h5 style="font-size:12px"><span class="fw-bold">Client Id: </span>${GetSpecificUser.clientId
    }</h5>
      </div>

      <div style="margin:20px">
      <p class="fw-bold">Contents</p>
      <table style="width: 100%" class="border-none">
  <tr class="border-none">
    <td style="width: 30%" class="border-none">Account & Proposal Details</td>
    <td style="width: 50%" class="border-none">
        ----------------------------------------------------------------------------------------
      </td>
    <td style="width: 20%" class="border-none">2</td>
  </tr>
  <tr class="border-none">
      <td style="width: 30%" class="border-none">Commercial Terms</td>
      <td style="width: 50%" class="border-none">
        ----------------------------------------------------------------------------------------
      </td>
      <td style="width: 20%" class="border-none">5</td>
    </tr>
    <tr class="border-none">
      <td style="width: 30%" class="border-none">Registration Schedule</td>
      <td style="width: 50%" class="border-none">
        ----------------------------------------------------------------------------------------
      </td>
      <td style="width: 20%" class="border-none">5</td>
    </tr>
    <tr class="border-none">
      <td style="width: 30%" class="border-none">Payment Terms</td>
      <td style="width: 50%" class="border-none">
        ----------------------------------------------------------------------------------------
      </td>
      <td style="width: 20%" class="border-none">5</td>
    </tr>
    <tr class="border-none">
      <td style="width: 30%" class="border-none">CAUSSA Terms & Conditions</td>
      <td style="width: 50%" class="border-none">
        ----------------------------------------------------------------------------------------
      </td>
      <td style="width: 20%" class="border-none">6</td>
    </tr>
</table>
      </div>
      <div style="height:630px"></div>
      ${TableHeader}
      <p>Dear Mr.</p>
      <p class="xs">
        Thank you for giving us the opportunity to provide our valued services
        and choosing CAUSSA as your trusted business partner. CAUSSA values your
        business and will make every effort to ensure that the following
        proposal meets with your current and future business requirements. I
        hope, that this proposal is in line with your needs and that the details
        used are accurate. If you feel that anything needs to be modified or
        doesn’t reflect your precise requirements, then please do let us know
      </p>
      <p class="xs">
        This proposal outlines how the ‘CAUSSA approach’ will support your
        organization to make your journey towards Certification easy and
        methodical.
      </p>
      <p class="xs">
        As a Certification Body we know Standards like nobody else. We are able
        to provide a full range of services from Training courses and Audit and
        Certification services, to support your journey. We look forward to call
        you over the next few days to check that you have all the information
        you need.
      </p>
      <p class="xs">
        A client relationship manager will be appointed to your organization to
        act as a focal point and to manage the certification cycle for all your
        programs. He/she will closely liaise with you to ensure a coordinated,
        integrated approach is taken during the planning of all audit
        activities. They will confirm and plan requirements strategically with
        site bookings and audit confirmations.
      </p>
      <p class="xs">
        Should you have any questions relating to this proposal or require
        further assistance with other CAUSSA services, then please contact me on
        the details below.
      </p>
      <p class="fw-bold xs">
        To accept this proposal, please complete pages 4 -6 and return to CAUSSA
        either via email or hard copy mail
      </p>
      <p class="xs">We look forward to working with you in the future</p>
      <p class="xs">Regards,</p>
      <p class="fw-bold xs">CAUSSA Tec Solutions Pvt Ltd</p>

      <!-- Account & Proposal Details -->
      <table class="Account-table no-break">
        <tr>
          <td colspan="4" class="fw-bold">Account Information</td>
        </tr>
        <tr>
          <td>Proposal Date :</td>
          <td>${dateOnly}</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Organization Name :</td>
          <td>${GetSpecificUser.companyName}</td>
          <td>Phone :</td>
          <td>${GetSpecificUser.phoneNumber}</td>
        </tr>
        <tr>
          <td>Contact Person :</td>
          <td>${GetSpecificUser.contactPerson}</td>
          <td>Email :</td>
          <td>${GetSpecificUser.email}</td>
        </tr>
        <tr>
          <td>Title :</td>
          <td>${SchemeType.title}</td>
          <td>City :</td>
          <td>${SchemeType.city}</td>
        </tr>
        <tr>
          <td>Address :</td>
          <td>${GetSpecificUser.address}</td>
          <td>State/Postcode :</td>
          <td>${GetSpecificUser.state}/${SchemeType.postCode}</td>
        </tr>
        <tr>
          <td>Billing Contact-Name & Designation :</td>
          <td>${SchemeType.billingContact.name} - ${SchemeType.billingContact.designation
    }</td>
          <td>PAN Number :</td>
          <td>${SchemeType.PAN}</td>
        </tr>
        <tr>
          <td>Expected Date of Audit Planned :</td>
          <td>${dateOnly1}</td>
          <td>GST Number :</td>
          <td>${SchemeType.GSTNumber}</td>
        </tr>
        <tr>
          <td colspan="2">Local Resource :</td>
          <td colspan="2">${SchemeType.localResource}</td>
        </tr>
      </table>
<div style="height:200px"></div>
      ${TableHeader}
      <!-- Proposal Information -->
      <table class="Proposal-table no-break">
        <tr>
          <td colspan="2">Proposal Information</td>
        </tr>
        <tr>
          <td colspan="2">
            The following is a proposal for the services you requested:
          </td>
        </tr>
        <tr>
          <td>Standard(s):</td>
          <td>${SchemeType.standards[0]}</td>
        </tr>
        <tr>
          <td>Certification Body:</td>
          <td>Legal entity of the Accredited unit, i.e. CAUSSA</td>
        </tr>
        <tr>
          <td>CAUSSA Contracting office:</td>
          <td>${SchemeType.CAUSSA_ContractingOffice}</td>
        </tr>
        <tr>
          <td>Accreditation(s) :</td>
          <td>${SchemeType.accreditations}</td>
        </tr>
        ${Scopeaudit}
        ${HACCP}
        <tr>
          <td>Total No. of employees:</td>
          <td>${SchemeType.totalNoOfEmployees}</td>
        </tr>
        <tr>
          <td>No. of effective:</td>
          <td>${SchemeType.noOfEffectiveFTE}</td>
        </tr>
        <tr>
          <td>No. of sites:</td>
          <td>${GetSpecificUser.noOfSites}</td>
        </tr>
        <tr>
          <td>No. of shifts:</td>
          <td>${SchemeType.noOfShifts}</td>
        </tr>
        <tr>
          <td> General Shift  : </td>
          <td>${SchemeType?.shift?.general ?? "0"}</td>
        </tr>
        <tr>
          <td> 1st Shift : </td>
          <td>${SchemeType?.shift?.first ?? "0"}</td>
        </tr>
        <tr>
          <td> 2nd Shift :</td>
          <td>${SchemeType?.shift?.second ?? "0"}</td>
        </tr>
        <tr>
          <td> 3rd Shift :</td>
          <td>${SchemeType?.shift?.third ?? "0"}</td>
        </tr>
        <tr>
          <td>Location (Multi-site info):</td>
          <td>${GetSpecificUser.state}/${SchemeType.postCode}</td>
        </tr>
        <tr>
          <td>HO / central office (if applicable):</td>
          <td>${SchemeType.HO_or_CentralOffice}</td>
        </tr>
        <tr>
          <td>Technical codes :</td>
          <td>${GetSpecificUser.technicalCode.mainCode} / ${GetSpecificUser.technicalCode.subCode
    }</td>
        </tr>
        <tr>
          <td>Surveillance Frequency :</td>
          <td>${SchemeType.surveillanceFrequency}</td>
        </tr>
      </table>
      ${TableHeader}
      <p style="padding-top: 10px">
        Description of certification activities and Audit Fees:
      </p>
      <table id="Main-table" class="no-break">
    <tr>
      <td rowspan="3" class="bg-Green text-center">Audit Type</td>
      <td colspan="4" class="bg-Green text-center">Year 1</td>
      <td colspan="4" class="bg-Green text-center">Year 2</td>
      <td colspan="4" class="bg-Green text-center">Year 3</td>
    </tr>
    <tr>
      <td colspan="3" class="bg-Green text-center">ManDays</td>
      <td rowspan="2" class="bg-Green text-center">Fee</td>
      <td colspan="3" class="bg-Green text-center">ManDays</td>
      <td rowspan="2" class="bg-Green text-center">Fee</td>
      <td colspan="3" class="bg-Green text-center">ManDays</td>
      <td rowspan="2" class="bg-Green text-center">Fee</td>
    </tr>
    <tr>
      <td class="bg-Green text-center">On-Site</td>
      <td class="bg-Green text-center">Off-Site</td>
      <td class="bg-Green text-center">Total</td>
      <td class="bg-Green text-center">On-Site</td>
      <td class="bg-Green text-center">Off-Site</td>
      <td class="bg-Green text-center">Total</td>
      <td class="bg-Green text-center">On-Site</td>
      <td class="bg-Green text-center">Off-Site</td>
      <td class="bg-Green text-center">Total</td>
    </tr>
    <tr>
      <td>Administration </br> Fee</td>
      <td></td>
      <td></td>
      <td></td>
      <td>
        ${SchemeType.auditCertificationActivitiesAndFees.administrationFee}
      </td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>Re-Certification</td>
      <td>
        ${SchemeType.auditCertificationActivitiesAndFees.re_Certification[0]
      .manDay.onSite
    }
      </td>
      <td>
        ${SchemeType.auditCertificationActivitiesAndFees.re_Certification[0]
      .manDay.offSite
    }
      </td>
      <td>
        ${SchemeType.auditCertificationActivitiesAndFees.re_Certification[0]
      .manDay.totalManDays
    }
      </td>
      <td>
        ${SchemeType.auditCertificationActivitiesAndFees.re_Certification[0]
      .manDay.fee
    }
      </td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>Survelliance </br> Audit - 1</td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td>
        ${SchemeType.auditCertificationActivitiesAndFees.surveillanceAudit[1]
      .manDay.onSite
    }
      </td>
      <td>
        ${SchemeType.auditCertificationActivitiesAndFees.surveillanceAudit[1]
      .manDay.offSite
    }
      </td>
      <td>
        ${SchemeType.auditCertificationActivitiesAndFees.surveillanceAudit[1]
      .manDay.totalManDays
    }
      </td>
      <td>
        ${SchemeType.auditCertificationActivitiesAndFees.surveillanceAudit[1]
      .manDay.fee
    }
      </td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>Survelliance </br> Audit - 2</td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td>
        ${SchemeType.auditCertificationActivitiesAndFees.surveillanceAudit[2]
      .manDay.onSite
    }
      </td>
      <td>
        ${SchemeType.auditCertificationActivitiesAndFees.surveillanceAudit[2]
      .manDay.offSite
    }
      </td>
      <td>
        ${SchemeType.auditCertificationActivitiesAndFees.surveillanceAudit[2]
      .manDay.totalManDays
    }
      </td>
      <td>
        ${SchemeType.auditCertificationActivitiesAndFees.surveillanceAudit[2]
      .manDay.fee
    }
      </td>
    </tr>
    <tr>
      <td></td>
      <td colspan="3">First Year Fee</td>
      <td>${SchemeType.auditCertificationActivitiesAndFees.surveillanceAudit[0]
      .totalFee
    }</td>
      <td colspan="3">Second Year Fee</td>
      <td>${SchemeType.auditCertificationActivitiesAndFees.surveillanceAudit[1]
      .totalFee
    }</td>
      <td colspan="3">Third Year Fee</td>
      <td>${SchemeType.auditCertificationActivitiesAndFees.surveillanceAudit[2]
      .totalFee
    }</td>
    </tr
    <tr>
      <td colspan="10">Total</td>
      <td colspan="4">
        ${SchemeType.auditCertificationActivitiesAndFees.totalContractFee}
      </td>
    </tr>
  </table>
     
      <p>Notes</p>
      <ul>
         <li data-list-text="" class="no-break"><p class="m-0">
          If it’s a transfer audit, identified audit activities are for a
          complete certification cycle.
        </p></li>
         <li data-list-text="" class="no-break"><p class="m-0">
       This quotation is based on the information provided by you.</p></li>
         <li data-list-text="" class="no-break"><p class="m-0">
          Annual fee includes scheduling/coordination of audits, technical
          review of audit reports, certificate fees (due to accreditation costs)
          and other dedicated account management support.
        </p></li>
         <li data-list-text="" class="no-break"><p class="m-0">
          ** if no changes at site (employee number or scope), contract remains
          in place and an annual multiplier is applied to reflect inflation.
        </p></li>
         <li data-list-text="" class="no-break"><p class="m-0">
          *** Variation in the management system, scope of activities at site or
          employee count will require a revised Proposal.
        </p></li>
         <li data-list-text="" class="no-break"><p class="m-0">
          **** Above numbers are validated for every audit during scheduling and
          after audit is completed to incorporate any changes identified by
          auditor(s) on site; any change in audit time will be communicated via
          an addendum to the current signed contract and will need your
          acknowledgement and/or acceptance. After the last surveillance audit
          this information will be validated by the auditor in support of the
          upcoming recertification audit. If no changes identified, contract
          would renew automatically.
        </p></li>
        </ul>
        <ul>
         <li data-list-text="" class="no-break"><p class="m-0">
          ****At the time of scheduling, the audit time will be re-assessed to
          include the composition and the size of the audit team (e.g. ½ day
          with 2 auditors may not be as effective as one day with 1 auditor,
          hence additional audit time may be added).
        </p></li>
         <li data-list-text="" class="no-break"><p class="m-0">
          Unforeseen circumstances may occur which would require additional
          services related to investigative activities. This includes on-site
          corrective action reviews resulting from not meeting the audit
          criteria. In addition, special audits may be necessary because of
          field complaints, product recalls and customer reports of poor trends
          in quality, delivery and/or services or related issues. Investigative
          visits of this type will be billed per day with travel costs and based
          on a minimum of one day.
        </p></li>
         <li data-list-text="" class="no-break"><p class="m-0">
          For quotations issued to transfer certificates from another accredited
          Certification body (accredited by an accreditation body who is
          signatory of an MLA), the above proposed services are conditioned by
          the successful completion of the transfer review (technical review of
          mandatory information).
        </p></li>
        <div style="height:80px"></div>
         ${TableHeader}
         <li data-list-text="" class="no-break"><p class="m-0">
          All Out of Pocket’s expenses such as travel expenses (airfare,
          mileage, hotels, car rental, meals, etc), local conveyance etc. will
          be charged and invoiced at actuals. In addition to the fees charged by
          us, GST 18%, and other government levies as applicable at the time of
          raising invoice shall be payable. This Quotation is valid for 90 days.
        </p></li>
      </ul>


      <p class="fw-bold">Invoicing</p>

      <ul>
         <li data-list-text="" class="no-break"><p class="m-0">
          Invoicing will be done upon completion of each activity. Audit,
          annual, and certification fees will be invoiced upon completion of
          each activity. Our charges become payable when the invoice is issued.
        </p></li>
      </ul>

      <p class="no-break fw-bold">Cancellation fees</p>

      <ul>
         <li data-list-text="" class="no-break"><p class="m-0">
          CAUSSA and you will mutually agree on a date for each activity per
          accreditation requirements. If you cancel any of the above without a
          thirty (30) day notice, you may be billed for incurred travel expenses
          and auditor downtime.
        </p></li>
      </ul>

      <p class="no-break fw-bold">Declaration</p>

      <ul>
         <li data-list-text="" class="no-break"><p class="m-0">
          I/ we accept the CAUSSA Standard Terms and Conditions of Contract as
          attached as per Annexure Term & Condition
        </p></li>
         <li data-list-text="" class="no-break"><p class="m-0">
          I/ we have read, understand and agree the proposal explanatory notes,
          and scheme specific requirements (as appropriate), and noted any
          additional scheme charges.
        </p></li>
         <li data-list-text="" class="no-break"><p class="m-0">
          I/ we confirm that we have conducted a full management system review
          and internal audit cycle in preparation for our initial audit. If not,
          the target date for completion is:
        </p></li>
         <li data-list-text="" class="no-break"><p class="m-0">
          I/ we confirm that I have authority to accept this contract on behalf
          of the organisation and for each additional site which included in the
          scope of certification (if applicable)
        </p></li>
        </ul>
        <ul>
         <li data-list-text="" class="no-break"><p class="m-0">
          In signing this application form, I affirm that I have the authority
          to enter this contract on behalf of the organisation.
        </p></li>
         <li data-list-text="" class="no-break"><p class="m-0">
          I/ we accept the CAUSSA payment terms, and I understand that all
          pricing are exclusive of GST 18% (as applicable)
        </p></li>
         <li data-list-text="" class="no-break"><p class="m-0">I/ we accept the CAUSSA cancellation policy.</p></li>
         <li data-list-text="" class="no-break"><p class="m-0">
          I/ we accept the CAUSSA travel and accommodation terms. Nothing in
          this proposal or in the terms and conditions will prevent CAUSSA from
          charging travel costs actually incurred.
        </p></li>
      </ul>

      <p>Quotation</p>
      <p class="mb-0">
        <span class="text-danger">Payment Terms:</span> Within 15 days upon
        issuance of an official invoice.
      </p>
      <p class="mb-0">
        Enclosure: Enclosure: Client Contract Terms & Conditions (Document No.
        CAUSSA-CB-F-20 Rev. No. 0 / OCT/2023)
      </p>
      <p class="fw-bold">Commercial Terms</p>
      <ul>
        <li class="fw-bold" data-list-text="">Flights / Travel Logistics</li>
      </ul>
      <ul class="list-type-none">
         <li data-list-text="" class="no-break">
         <p class="m-0" style="display: inline-block; vertical-align: bottom;">
  <span class="small-box" style="height:10px;width:10px;border:1px solid black;display:inline-block;vertical-align:bottom;"></span>
  <span>CAUSSA to kindly arrange the auditor’s flight / travel to my location,
  cost of the same will be charged as actual & billed to Client.</span>
</p></li>
         <li data-list-text="" class="no-break"><p class="m-0" style="display: inline-block; vertical-align: bottom;">
          <span class="small-box" style="height:10px;width:10px;border:1px solid black;display:inline-block;vertical-align:bottom;"></span>
          <span>We agree to pay Admin fee of 10% on the Travel cost so paid by CAUSSA
          and billed to us. I will arrange the auditor’s flight / travel to my
          location.</span>
        </p></li>
      </ul>


      <div style="height:70px"></div>
      ${TableHeader}

      <ul>
        <li class="fw-bold" data-list-text="">Accommodations</li>
      </ul>
      <ul class="list-type-none">
         <li data-list-text="" class="no-break"><p class="m-0" style="display: inline-block; vertical-align: bottom;">
          <span class="small-box" style="height:10px;width:10px;border:1px solid black;display:inline-block;vertical-align:bottom;"></span>
          <span>CAUSSA to kindly arrange the auditor’s accommodation during the audit
          period. CAUSSA to use only 3-star accommodation cost of the same will
          be charged as actual & billed to Client We agree to pay Admin fee of 10%
          on the accommodation cost so paid by CAUSSA and billed to us</span>
        </p></li>
         <li data-list-text="" class="no-break"><p class="m-0" style="display: inline-block; vertical-align: bottom;">
          <span class="small-box" style="height:10px;width:10px;border:1px solid black;display:inline-block;vertical-align:bottom;"></span>
          <span>I will arrange the auditor’s accommodation during the audit period. I
          agree to a minimum of a 3-star accommodation.</span>
        </p></li>
      </ul>
      <ul>
         <li data-list-text="" class="no-break"><p class="m-0">Registration fees exclude changes or extension to scope.</p></li>
         
         <li data-list-text="" class="no-break"><p class="m-0">
          The proposed man-days duration are based on information provided by
          Client If the actual situation differs, audit man-days duration period
          will be adjusted accordingly.
        </p></li>
         <li data-list-text="" class="no-break"><p class="m-0">
          Client will be invoiced based on actual expenses; which will be limited
          to the fees listed within the quotation.
        </p></li>
         <li data-list-text="" class="no-break"><p class="m-0">Fees quoted are subjected to GST 18%</p></li>
      </ul>
      <p class="no-break">
        CAUSSA will charge for all travel costs incurred along with the Admin
        Fee in providing services to Client CAUSSA will endeavour to use local
        auditors wherever available locally, however the certain products &
        services may require specialists.
      </p>
      <p class="no-break">
        The scheme offered to you is “Triennial Reaudit Scheme” (TRS) as per the
        requirement of ISO 17021:2015 and accreditation rules. After completion
        of Surveillance Audits your management system will be re-validated by
        conducting a re-audit (every third year).
      </p>
      <p class="no-break">
        For the purpose of the maintenance of registration continuing audit
        visits are performed at 6, 9, 12 monthly intervals. The recertification
        audit should be ideally performed on the 34th month from the
        certification date to ensure continuity is maintained.
      </p>
      <p class="fw-bold">Registration Schedule</p>
      <p class="no-break">
        CAUSSA proposes to execute the registration activities at dates mutually
        agreed upon and issue the certificate within six [6] weeks of
        satisfactory audit completion/ Client responses to registration audit
        findings (if any).
      </p>
      <p class="no-break">
        Since it is normal that CAUSSA’s manpower is committed on running
        projects at any given time, Client is expected to intimate the Initial
        Visit (Pre-audit) and audit dates at least four [4] weeks in advance.
      </p>
      <p class="no-break">
        Any rescheduling or cancellation within 15 days of the scheduled date of
        commencement would be invoiced for the audit duration.
      </p>
      <p class="fw-bold">Payment Terms</p>
      <p class="no-break">
        Invoicing will be done after each service delivery and will be in line
        with the “General terms and conditions” listed as per Annexure in this
        proposal.
      </p>
      <p class="no-break">
        All payments must be made by DD/Cheque payable in favour of “CAUSSA
        TEC”, online payments through NEFT (details mentioned below) is also an
        acceptable payment mode. All Invoices shall be settled within 30 days
        from delivery of service.
      </p>
      <p class="fw-bold m-0">NEFT Details: </p>
      <p class="fw-bold m-0">Bank Name : Axis Bank</p>
      <p class="fw-bold m-0">Account Number : 920020055738614</p>
      <p class="fw-bold m-0">Branch Name : West Tambaram</p>
      <p class="fw-bold m-0">IFSC Code : UTIB0000428</p>
      <p class="fw-bold m-0">GST Number : 33AAGCC7121D1Z7</p>
      <p class="no-break">
        Registration Fees shall be paid in advance together with Signed
        Agreement. This fee is non- refundable.
      </p>
      <p class="fw-bold no-break">CAUSSA Terms & Conditions Annexure A</p>
      <ul>
         <li data-list-text="" class="no-break"><p class="m-0">
          You must conform to the requirements of the CAUSSA when referring to
          your certification status in communication media such as the internet,
          brochures or advertising, or other documents.
        </p></li>
         <li data-list-text="" class="no-break"><p class="m-0">
          You do not make or permit any misleading statement regarding your
          certification.
        </p></li>
          <div style="height:40px"></div>
        ${TableHeader}
         <li data-list-text="" class="no-break"><p class="m-0">
          You do not use or permit the use of a certification document or any
          part thereof in a misleading manner.
        </p></li>
       
         <li data-list-text="" class="no-break"><p class="m-0">
          upon withdrawal of your certification, You have to discontinue the use
          of all advertising matter that contains a reference to certification,
          as directed by the certification body
        </p></li>
         <li data-list-text="" class="no-break"><p class="m-0">
          You have to amend all advertising matter when the scope of
          certification has been reduced;
        </p></li>
         <li data-list-text="" class="no-break"><p class="m-0">
          You do not allow reference to your management system certification to
          be used in such a way as to imply that CAUSSA certifies a product
          (including service) or process;
        </p></li>
        
         <li data-list-text="" class="no-break"><p class="m-0">
          You do not imply that the certification applies to activities and
          sites that are outside the scope of certification;
        </p></li>
        
         <li data-list-text="" class="no-break"><p class="m-0"> 
          You do not use your certification in such a manner that would bring
          CAUSSA and/or certification system into disrepute and lose public
          trust.
        </p></li>
      </ul>
      <table class="no-break" style="margin-top:20px">
        <tr>
          <td class="border-bottom-none">
            Sales Representative & CAUSSA’s Authorized person.
          </td>
          <td class="border-bottom-none">Signature of Authorized Person:</td>
        </tr>
        <tr>
          <td class="border-bottom-none border-top-none"></td>
          <td class="border-bottom-none border-top-none"></td>
        </tr>
        <tr>
          <td class="border-top-none border-bottom-none">Date : ${formattedDate}</td>
          <td class="border-top-none border-bottom-none">Date</td>
        </tr>
        <tr>
          <td class="border-top-none border-bottom-none">Name : ${localStorage.getItem(
      "firstName"
    )} ${localStorage.getItem("lastName")}</td>
          <td class="border-top-none border-bottom-none">Name</td>
        </tr>
        <tr>
          <td class="border-top-none border-bottom-none">Signature</td>
          <td class="border-top-none border-bottom-none">Designation</td>
        </tr>
        <tr>
          <td style="height:100px" class="border-top-none">
          <img src=${parsedFormData.SalePersonSign
    } style="width:100px;height:100px"/></td>
          <td  style="height:100px" class="border-top-none">
            Signature & Company Seal
          </td>
        </tr>
        
      </table>
    </div>
  </body>
</html>
`;
}

export default ReCertificationTable;
